import { Component } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '@app/core/services/auth.service';
import { HTTP_STATUS_CODE } from '@app/core/constants/system.constants';

/**
 * Modal nhập mã 2FA dùng chung cho cơ chế Step-up ("sudo mode").
 * Được `StepUpService` tạo động khi một API bất kỳ trả `MFA_STEP_UP_REQUIRED`.
 * Đóng modal với kết quả `true` khi step-up thành công, `false` khi hủy.
 */
@Component({
  selector: 'app-step-up-2fa-modal',
  template: `
    <div class="stepup">
      <p class="stepup__desc">
        Thao tác này cần xác thực 2 lớp. Nhập mã 6 số từ ứng dụng Authenticator của bạn.
      </p>
      <input class="stepup__input" type="text" inputmode="numeric" maxlength="6"
             placeholder="Nhập mã 6 số" [(ngModel)]="code" (keyup.enter)="submit()" autofocus/>
      <div class="stepup__actions">
        <button nz-button type="button" (click)="cancel()">Hủy</button>
        <button nz-button nzType="primary" type="button" [nzLoading]="loading" (click)="submit()">Xác nhận</button>
      </div>
    </div>
  `,
  styles: [`
    .stepup__desc { font-size: 13px; color: #475569; margin: 0 0 12px; line-height: 1.5; }
    .stepup__input {
      width: 100%; height: 44px; padding: 10px 14px; border: 1px solid #e2e8f0;
      border-radius: 8px; font-size: 16px; letter-spacing: 0.15em; box-sizing: border-box;
    }
    .stepup__input:focus { outline: none; border-color: #1e3a8a; box-shadow: 0 0 0 2px rgba(30,58,138,0.1); }
    .stepup__actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px; }
  `]
})
export class StepUp2faModalComponent {
  code = '';
  loading = false;

  constructor(
    private modalRef: NzModalRef,
    private authService: AuthService,
    private toastr: ToastrService
  ) {}

  submit(): void {
    if (!this.code || this.loading) return;
    this.loading = true;
    this.authService.stepUp(this.code).subscribe({
      next: (res) => {
        this.loading = false;
        if (res?.code === HTTP_STATUS_CODE.SUCCESS) {
          this.modalRef.close(true);
        } else {
          this.toastr.error(res?.message);
        }
      },
      error: (err) => {
        this.loading = false;
        this.toastr.error(err?.error?.message || 'Mã xác thực không đúng');
      }
    });
  }

  cancel(): void {
    this.modalRef.close(false);
  }
}
